<template>
  <div>
    <div class="formBox margbot" ref="inpBox">
      <el-form :inline="true" :model="formData" ref="formData" size="mini" label-width="90px">
        <div class="formItemBox">
          <el-form-item label="一级货主:">
            <el-select v-model="formData.primaryCustomerTaxId" clearable filterable placeholder="请选择">
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName" :value="item.taxpayerNumber" >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:">
            <el-select v-model="formData.customerTaxId" clearable filterable placeholder="请选择">
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName" :value="item.taxpayerNumber" >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="移库时间:" >
            <div style="display: flex;">
              <el-date-picker v-model="formData.transferDateStart" type="datetime" placeholder="选择移库日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              -
              <el-date-picker v-model="formData.transferDateEnd" placeholder="选择移库日期" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="货物类型:">
            <el-select v-model="formData.productType" placeholder="请选择货物类型" filterable clearable @change="productTypeChange">
              <el-option v-for="(item,index) in productTypeData" :key="index" :label="item.productTypeName" :value="item.productType"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地:">
            <el-select v-model="formData.steelMillName" placeholder="请选择产地"  filterable clearable @change="steelMillNameChange">
              <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格:">
            <el-select v-model="formData.specification" placeholder="请选择规格" filterable clearable @change="specificationChange">
              <el-option v-for="(item,index) in specificationData" :key="index"
                :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材质:">
            <el-select v-model="formData.model" placeholder="请选择材质" filterable clearable @change='modelChange'>
              <el-option v-for="(item,index) in modelData" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="移库前仓位:">
            <el-select v-model="formData.warehouseId" placeholder="请选择移库前仓位" filterable clearable>
              <el-option v-for="item in ckData" :key="item.warehouseId" :label="item.warehouseName" :value="item.warehouseId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="移库后仓位:">
          <el-select v-model="formData.transferWarehouseId" placeholder="请选择移库后仓位" filterable clearable>
            <el-option v-for="item in ckData" :key="item.warehouseId" :label="item.warehouseName" :value="item.warehouseId"></el-option>
          </el-select>
        </el-form-item>
        </div>
        <el-form-item style="padding-left: 10px;">
          <el-button type="primary" size="mini" @click="chaxun" btnCode="00cP00BB00G" v-if="btnFlg[15]">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi" btnCode="00cP00BB00H" v-if="btnFlg[16]">重置</el-button>
          <el-button type="primary" size="mini" @click="daochu" btnCode="00cP00BB00I" v-if="btnFlg[17]">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div :style="{ height: H }">
      <el-table
        height="100%"
        size="mini"
        ref="tabref"
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          background: '#F5F5F5',
          color: 'black',
        }"
        highlight-current-row
        border
        center
        bordersize="mini"
      >
        <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" label="移库时间" align="center" width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center" width="100" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="移库前仓位" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="transferWarehouseName" label="移库后仓位" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="transferNumber" label="移库件数" align="center" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" property="transferStockWeight" label="移库理重（吨）" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="transferPoundWeight" label="移库磅重（吨）" width="120" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="plateNumber" label="车船号" align="center" width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="shipForecastNo" label="预报编号" align="center" width="300"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUser" label="操作人" width="120" align="center"></el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="pags">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="pageInfo.pageNo"
        :page-size="pageInfo.pageSize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { getRelationCustomer, jfgetTransferRecordExpList, getVirtualBalingList } from '@/api/wms-stock'
import { zidianKuwei } from '@/api/wms-access'
import DonMessage from '@/utils/message'
import { exportExcel } from '@/utils/fileDown.js'
export default {
  data () {
    return {
      formData: {
        transferDateStart: '',
        transferDateEnd: '',
        primaryCustomerTaxId: '',
        customerTaxId: '',
        specification: '',
        model: '',
        warehouseId: '',
        transferWarehouseId: '',
        steelMillName: '',
        productType: ''
      },
      btnFlg: [],
      btnArr: [
        // 入库记录
        '00cP00BB001',
        '00cP00BB002',
        '00cP00BB003',
        '00cP00BB004',
        // 进仓记录
        '00cP00BB005',
        '00cP00BB006',
        '00cP00BB007',
        // 出库记录
        '00cP00BB008',
        '00cP00BB009',
        '00cP00BB00A',
        '00cP00BB00B',
        // 转货记录
        '00cP00BB00C',
        '00cP00BB00D',
        '00cP00BB00E',
        '00cP00BB00F',
        // 移库记录
        '00cP00BB00G',
        '00cP00BB00H',
        '00cP00BB00I',
        // 亏涨记录
        '00cP00BB00J',
        '00cP00BB00K',
        '00cP00BB00L',
        // 删除记录
        '00cP00BB00M',
        '00cP00BB00N',
        '00cP00BB00O',
        // 撤销记录
        '00cP00BB00P',
        '00cP00BB00Q',
        '00cP00BB00R',
        // 入库过磅记录
        '00cP00BB00S',
        '00cP00BB00T',
        '00cP00BB00U',
        '00cP00BB00V',
        '00cP00BB00W',
        '00cP00BB00X',
        // 出库过磅记录
        '00cP00BB00Y',
        '00cP00BB00Z',
        '00cP00BB00a',
        '00cP00BB00b',
        '00cP00BB00c',
        '00cP00BB00d'
      ],
      tableData: [],
      H: '500px',
      pageInfo: {
        pageSize: 20,
        pageNo: 1
      },
      RKData: [],
      productTypeData: [],
      total: 0,
      specificationData: [],
      modelData: [],
      ckData: [],
      steelMillNameData: [],
      goodsName: '',
      placeOfOrigin: '',
      specificationVal: '',
      modelVal: ''
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/yycJiLuChaXun')
    this.getRelationCustomerS()
    this.zidianKuweiS()
    this.getTransferRecordLists()
    this.getVirtualBalingList()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    let h = this.$refs.inpBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.H = pH - h - 202 + 'px'
  },
  methods: {
    chaxun () {
      this.getTransferRecordLists()
    },
    chongzhi () {
      this.formData.primaryCustomerTaxId = ''
      this.formData.customerTaxId = ''
      this.formData.transferDateStart = ''
      this.formData.transferDateEnd = ''
      this.formData.specification = ''
      this.formData.model = ''
      this.formData.warehouseId = ''
      this.formData.transferWarehouseId = ''
      this.formData.steelMillName = ''
      this.formData.productType = ''
      this.goodsName = ''
      this.placeOfOrigin = ''
      this.specificationVal = ''
      this.modelVal = ''
      this.getTransferRecordLists()
      this.getVirtualBalingList()
    },
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/stockExpInfo/exportTransferRecordExpList',
        { ...this.formData },
        '移库记录表'
      )
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.getTransferRecordLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.getTransferRecordLists()
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      // this.goodsName = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 主表
    getTransferRecordLists () {
      jfgetTransferRecordExpList(
        {
          pageNo: this.pageInfo.pageNo,
          pageSize: this.pageInfo.pageSize,
          transferDateStart: this.formData.transferDateStart,
          transferDateEnd: this.formData.transferDateEnd,
          specification: this.formData.specification,
          model: this.formData.model,
          warehouseId: this.formData.warehouseId,
          transferWarehouseId: this.formData.transferWarehouseId,
          steelMillName: this.formData.steelMillName,
          productType: this.formData.productType,
          primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
          customerTaxId: this.formData.customerTaxId
        }
      )
        .then(res => {
          this.tableData = res.list
          this.total = res.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
      })
        .then((res) => {
          this.RKData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({
      })
        .then((res) => {
          this.ckData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    }
  }
}
</script>

<style lang="less" scoped>
.inpBox{
  .el-form-item{
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
</style>
